import { render } from "./CdrTestSidebar.vue?vue&type=template&id=5f9c3d8a&scoped=true&ts=true"
import script from "./CdrTestSidebar.vue?vue&type=script&lang=ts"
export * from "./CdrTestSidebar.vue?vue&type=script&lang=ts"

import "./CdrTestSidebar.vue?vue&type=style&index=0&id=5f9c3d8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9c3d8a"]])

export default __exports__